module.exports = __webpack_public_path__ + "img/pause.ca3476ae.svg";